import { observer } from 'mobx-react'
import React from 'react'
import { GlobalHotKeys } from 'react-hotkeys'

import { keyboardShortcuts } from '@flowwai-frontend/bps-officer-web/common/ui'
import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { ReactBaseModalContainer } from '@flowwai-frontend/shared/common-components'

import GlobalSearchController from '../../controllers/GlobalSearchController/GlobalSearchController'
import { useGlobalSearchUIStore } from '../../hooks/stores/useGetGlobalSearchUIStore'

import './styles.css'

const GlobalSearchModal = (): React.ReactElement => {
   const globalSearchUIStore = useGlobalSearchUIStore()
   const {
      isGlobalSearchModalOpen,
      closeGlobalSearchModal,
      setGlobalSearchModalOpen
   } = globalSearchUIStore

   //TODO: Don't open search if pipeline data is not loaded
   const onClickSearch = event => {
      if (Config.ENABLE_GLOBAL_SEARCH === 'false') return

      event.preventDefault()
      setGlobalSearchModalOpen()
   }

   const keyMap = {
      OPEN_SEARCH: [
         keyboardShortcuts.openGlobalSearch1,
         keyboardShortcuts.openGlobalSearch2
      ]
   }

   const handlers = {
      OPEN_SEARCH: onClickSearch
   }

   return (
      <GlobalHotKeys keyMap={keyMap} handlers={handlers}>
         <ReactBaseModalContainer
            onClickCloseIcon={closeGlobalSearchModal}
            isOpen={isGlobalSearchModalOpen}
            className='global-search-model'
            overlayClassName='global-search-model-overlay'
            shouldCloseOnEsc={true}
            hideCloseIcon={true}
            data-testid='officer-global-search-modal'
         >
            <GlobalSearchController />
         </ReactBaseModalContainer>
      </GlobalHotKeys>
   )
}

export default observer(GlobalSearchModal)
